var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#E6EBF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 19V25C32 27.5 31.5 29.25 30.38 30.38L24 24L31.73 16.27C31.91 17.06 32 17.96 32 19Z",
    stroke: "#6E787E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.73 16.27L16.27 31.73C13.26 31.04 12 28.96 12 25V19C12 14 14 12 19 12H25C28.96 12 31.04 13.26 31.73 16.27Z",
    stroke: "#6E787E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.38 30.38C29.25 31.5 27.5 32 25 32H19C17.96 32 17.06 31.91 16.27 31.73L24 24L30.38 30.38Z",
    stroke: "#6E787E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.24 17.9802C16.92 15.0502 21.32 15.0502 22 17.9802C22.39 19.7002 21.31 21.1602 20.36 22.0602C19.67 22.7202 18.58 22.7202 17.88 22.0602C16.93 21.1602 15.84 19.7002 16.24 17.9802Z",
    stroke: "#6E787E",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0946 18.7002H19.1036",
    stroke: "#6E787E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapcircle);
export default __webpack_public_path__ + "static/media/mapcircle.95e9cf75b5db5889525c9f15011408be.svg";
export { ForwardRef as ReactComponent };